import { render, staticRenderFns } from "./NoDataAnimation.vue?vue&type=template&id=768ac337&scoped=true"
var script = {}
import style0 from "./NoDataAnimation.vue?vue&type=style&index=0&id=768ac337&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ac337",
  null
  
)

export default component.exports